import { debounce } from 'debounce';
import { getField } from "./getters";
import { settings } from "./constants";
import { state } from "./state";
import { INSTALLMENT_ACTIVE } from "./_main";

export const setPrice = () => {
  const formatted = `${$.number(state.sale_price, 0, '', ' ')} руб.`;
  const field = getField('price');
  field.querySelector('[data-price]').innerHTML = formatted;
};

export const setSale = sale => {
  const formatted = `${$.number(sale, 0, '', ' ')} руб.`;
  const field = getField('sale');
  field.querySelector('[data-price]').innerHTML = formatted;
};

export const setTradeIn = trade => {
  const formatted = `${$.number(trade, 0, '', ' ')} руб.`;
  const field = getField('trade-in');
  const checkbox = field.querySelector('[type=checkbox]');
  checkbox.checked = false;
  field.querySelector('[data-price]').innerHTML = formatted;
  field.querySelector('[type=checkbox]').value = trade;
};

export const setDirectSale = direct => {
  const formatted = `${$.number(direct, 0, '', ' ')} руб.`;
  const field = getField('direct-sale');
  const checkbox = field.querySelector('[type=checkbox]');
  checkbox.checked = false;

  if (direct) {
    field.style.display = '';
    field.querySelector('[data-price]').innerHTML = formatted;
    checkbox.value = direct;
  } else {
    field.style.display = 'none';
  }
};

export const setBenefit = benefit => {
  const formatted = `${$.number(benefit, 0, '', ' ')} руб.`;
  const field = getField('benefit');
  const checkbox = field.querySelector('[type=checkbox]');
  checkbox.checked = false;
  if (benefit) {
    field.style.display = '';
    field.querySelector('[data-price]').innerHTML = formatted;
    checkbox.value = benefit;
  } else {
    field.style.display = 'none';
  }
};

export const setTradeInOther = trade => {
  const field = getField('trade-in-other');
  const formatted = `${$.number(trade, 0, '', ' ')} руб.`;
  const checkbox = field.querySelector('[type=checkbox]');
  checkbox.checked = false;
  if (trade) {
    field.style.display = '';
    field.querySelector('[data-price]').innerHTML = formatted;
    checkbox.value = trade;
  } else {
    field.style.display = 'none';
  }
};

export const setPacket = price => {
  const field = getField('installment-packet');
  const formatted = `${$.number(price, 0, '', ' ')} руб.`;
  if (INSTALLMENT_ACTIVE) {
    field.style.display = '';
  } else {
    field.style.display = 'none';
  }
  field.querySelector('[data-price]').innerHTML = formatted;
};


const getMaxPV = price => {
  price = parseInt(price);
  const pv = (price + settings.GAP * price * settings.YEARS - (settings.MIN_CREDIT * (1 - settings.SZH * settings.YEARS)));
  const maxPv = price * settings.MAX_CREDIT_PERCENT;
  return pv > maxPv ? maxPv : pv;
};

const getMinPV = price => {
  price = parseInt(price);

  const pv = (price + settings.GAP * price * settings.YEARS - (settings.MAX_CREDIT * (1 - settings.SZH * settings.YEARS)));
  return (pv < price * settings.MIN_CREDIT_PERCENT) ? price * settings.MIN_CREDIT_PERCENT : pv;
};

const setCurrentPrice = (bar, min, price, max) => {
  state.price = price;
  const percent = (price - min) / (max - min) * 100;
  bar.css('left', `${percent}%`);
  bar.html(`${$.number(price, 0, '', ' ')} руб.`);
  calculateCredits();
};

const setBars = (field, min, start, max) => {
  const minBar = field.find('.finance__bar-min');
  const maxBar = field.find('.finance__bar-max');
  const currentBar = field.find('.finance__bar-current');
  setCurrentPrice(currentBar, min, start, max);
  minBar.html(`${$.number(min, 0, '', ' ')} руб.`);
  maxBar.html(`${$.number(max, 0, '', ' ')} руб.`);
  setTimeout(() => {
    currentBar.css('transform', `translateX(-${currentBar.width() / 2}px)`);
    minBar.css('transform', `translateX(-${minBar.width() / 2}px)`);
    maxBar.css('transform', `translateX(-${maxBar.width() / 2}px)`);
  },
    0);
};

const updatePrice = (obj, bar) => {
  const field = bar.parent().find('.finance__bar-current');
  setCurrentPrice(field, bar.slider('option', 'min'), obj.value, bar.slider('option', 'max'));
};

export const setPv = () => {
  const field = $(getField('pv'));
  const bar = field.find('[bar]');
  // const max = getMaxPV(state.sale_price);
  const max = state.sale_price;
  const min = getMinPV(state.sale_price);
  const start = parseInt($.number(Math.floor(min + (max - min) / (100 / 75)), 0, '', ''));
  setBars(field, min, start, max);

  bar.slider({
    min: min,
    max: max,
    value: start,
    change: (e, obj) => updatePrice(obj, bar),
    slide: (e, obj) => updatePrice(obj, bar),
    create: () => {
      const list = [1, ...Array(9).keys().map(i => (i + 1) * 10), 99];
      $('.finance__bar').append(`<div class="finance__bar_percentages">${list.map(i => `<div>${i}%</div>`).join('')}</div>`);
    }
  });
};

export const setSrok = () => {
  const field = $(getField('srok'));
  state.srok = $(field).find('.label-choose__item.active').attr('data-value');
  field.find(`.label-choose__item[data-value="${state.srok}"]`).eq(0).click();
};

const updateList = (programs, selectedModelId) => {
  selectedModelId = selectedModelId || 0;
  const srok = settings.YEARS * settings.MONTH;
  const ids = [];
  const pvPercent = state.price / parseFloat(state.sale_price);
  let listItems = $(getField('list')).find('.finance__list-item');
  programs.forEach(({ id }) => ids.push(id));
  listItems.each((i, e) => e.style.display = 'none');
  listItems = listItems.filter((i, { dataset: { id } }) => ids.includes(id));
  listItems.each((i, e) => {
    const program = $(e);
    const programSettings = { ...settings };
    let programData;
    programSettings.SROK = srok;
    if ($(e).data('id') === 7) {
      if (state.complectation.model_name === "CS75FL") {
        $('#credit_online').hide();
      } else {
        $('#credit_online').show();
        $('#credit_online').attr('href', 'https://anketa.vtb.ru/credit-auto?product=autoLite&program=Экстра Direct&dealer=114180274&logo=changan&tr_kind=auto&brand=Changan&reado=1000000&price=' + state.sale_price + '&initialpmt=' + state.price + '&period=' + srok + '&model=' + state.complectation.model_name);
      }
    }
    if (INSTALLMENT_ACTIVE) {
      programData = programs.find(({ id }) => e.dataset.id === id);
      programSettings.STAVKA = 0;
      programSettings.packet = parseFloat(programData.installment_packet_price);
      program.find('[data-service]').each((i, service) => {
        service.querySelector('[type=checkbox]').checked = false;
        service.style.display = 'none';
      });
      program.find('[data-title]').each((i, title) => {
        if (title.dataset.title === 'main') {
          title.style.display = 'none';
        } else {
          title.style.display = '';
        }
      });
      program.find('[data-rate-insurance]').hide();
      program.find('[data-packet]').show();
    } else {
      program.find('[data-service]').each((i, service) => service.style.display = '');
      program.find('[data-title]').each((i, title) => {
        if (title.dataset.title !== 'main') {
          title.style.display = 'none';
        } else {
          title.style.display = '';
        }
      });
      programData = programs.find(({ id }) => e.dataset.id === id).data[srok];
      const targetInterval = Object.keys(programData).find(interval => {
        const intervalList = interval.split('-').map(item => parseFloat(item) / 100);
        if (intervalList.length === 1) {
          return intervalList[0] <= pvPercent;
        } else {
          return (intervalList[0] <= pvPercent) && (intervalList[1] >= pvPercent);
        }
      });
      const targetData = programData[targetInterval];
      programSettings.STAVKA = targetData.rate;
      program.find('[data-packet]').hide();

      if (programSettings.STAVKA !== 'null') {
        programSettings.STAVKA = parseFloat(programSettings.STAVKA) / 100;
        programSettings.SZH = 0;
        program.find('[data-rate-insurance]').hide();
      } else {
        programSettings.STAVKA = parseFloat(targetData.rate_insurance) / 100;
        programSettings.SZH = 0.00167;
        program.find('[data-rate-insurance]').show();
      }
    }
    let displayProgram = true;
    if (selectedModelId > 0) {
      let creditInfo = state.credits.find(({ id }) => id == program.data('id'));
      if (Array.isArray(creditInfo.models)) {
        displayProgram = creditInfo.models.includes(selectedModelId);
      }
    }
    const price = getPrice(parseFloat(state.sale_price), state.price, programSettings);
    e.style.display = displayProgram ? '' : 'none';
    const elAfterPoint = (programSettings.STAVKA * 100).toString().includes('.') ? (programSettings.STAVKA * 100).toString().split('.').pop().length : 0;
    program.find('[data-value="per-month"]').text(`${price} руб.`);
    program.find('[data-value=rate]').text(`${elAfterPoint > 1 ? (programSettings.STAVKA * 100).toFixed(2) : (programSettings.STAVKA * 100).toFixed(1)}%`);
    // const priceTotal = getMaxPV(state.sale_price) - state.price
    const priceTotal = state.sale_price - state.price
    program.find('[data-value=credit]').text(`${$.number(priceTotal, 0, '', ' ')} руб.`);
  });
};

export const getPercentListFromTerm = term => {
  let list = [];
  if (term) {
    Object.keys(term).forEach(percentInterval => {
      list = [...list, ...percentInterval.split('-')];
    });
  }
  return list;
};

export const calculateCredits = debounce(() => {
  let programs = state.credits;
  const pvPercent = state.price / parseFloat(state.sale_price);
  const selectedModelId = $('[data-model].active').length == 1 ? $('[data-model].active')[0].dataset.model : 0;

  if (INSTALLMENT_ACTIVE) {
    const installmentPrice = state.sale_price - state.price;

    programs = programs
      // filter by price
      .filter(credit => {
        return credit.installment &&
          (parseFloat(credit.installment.min_sum) <= installmentPrice) &&
          (parseFloat(credit.installment.max_sum) >= installmentPrice);
      })
      // filter by PV
      .filter(credit => pvPercent >= parseFloat(credit.installment.pv));

  } else {
    programs = programs
      // filter by price
      .filter(credit => (parseFloat(credit.min_sum) <= state.price) && (parseFloat(credit.max_sum) >= state.price))
      // filter by PV
      .filter(credit => {
        let percentList = [...getPercentListFromTerm(credit.data[settings.YEARS * settings.MONTH])];
        percentList = Array.from(new Set(percentList)).map(percent => parseFloat(percent)).sort((a, b) => a - b);
        return (pvPercent >= (percentList[0] / 100)) && (pvPercent <= (percentList[percentList.length - 1] / 100));
      });
  }
  updateList(programs, selectedModelId);
}, 200);

const getPrice = (price, PV, settings) => {
  if (price === 0)
    return '';
  // let toCredit = getMaxPV(price) - PV;
  let toCredit = price - PV;

  if (INSTALLMENT_ACTIVE) {
    if (getField('installment-packet').querySelector('[type=checkbox]').checked) {
      toCredit += settings.packet;
    }
    return $.number(Math.floor(toCredit / settings.SROK), 0, '', ' ');
  }

  // const credit = toCredit + parseFloat($.number((toCredit) / (1 - settings.SZH * settings.SROK) - (toCredit), 2, '.', '')); // credit price + strahovanie zhizni
  // return $.number(Math.floor(pmt(settings.STAVKA / settings.MONTH, settings.SROK, credit * -1)), 0, '', ' ');
  return $.number(Math.floor(creditFormula(settings.STAVKA, settings.SROK, toCredit)), 0, '', ' ');
};

/**
 * Copy of Excel's PMT function.
 * Credit: http://stackoverflow.com/questions/2094967/excel-pmt-function-in-js
 *
 * @param rate_per_period       The interest rate for the loan.
 * @param number_of_payments    The total number of payments for the loan in months.
 * @param present_value         The present value, or the total amount that a series of future payments is worth now;
 *                              Also known as the principal.
 * @returns {number}
 */
const pmt = (rate_per_period, number_of_payments, present_value) => {
  const q = Math.pow(1 + rate_per_period, number_of_payments);
  return -(rate_per_period * ((q * present_value))) / ((-1 + q));
};

/**
 * Credit formula.
 *
 * @param {number} rate_per_period - The interest rate for the loan, per month.
 * @param {number} number_of_payments - The total number of payments for the loan.
 * @param {number} present_value - The present value, or the total amount that a series of future payments is worth now;
 *                                Also known as the principal.
 * @returns {number} - The monthly payment amount.
 */
const creditFormula = (rate_per_period, number_of_payments, present_value) => {
  const rate = rate_per_period / 12;
  return (present_value * rate) / (1 - Math.pow(1 + rate, -number_of_payments));
};
